import { getCurrentUserState, splitTestEnabled } from 'lib/helpers';
import Cookies from 'js-cookie';
import EzPopunder from 'components/util/ez-popunder';

const PARTNER_POPUP_PAGINATION = 'partner_popup_pagination';
const PARTNER_POPUP_SEARCH_VIEWS = 'partner_popup_search_views';
const PARTNER_POPUP_SHOW_VIEWS = 'partner_popup_show_views';
const PARTNER_POPUP_SEEN_RECENTLY = 'sstkSearchPU';

const PARTNER_POPUP_SEARCH_VIEWS_LIMIT = 4;
const PARTNER_POPUP_SHOW_VIEWS_LIMIT = 6;

export const seenRecently = () => {
  const cookie = Cookies.getJSON(PARTNER_POPUP_SEEN_RECENTLY);

  if (!cookie) return false;

  const thirtyMinutes = 1000 * 60 * 30;
  const threshold = Date.now() - thirtyMinutes;

  return cookie.lastSeen > threshold;
};

export const canSeePartnerPopup = () => {
  if (!document.body.dataset.showPartnerPopups) return false;
  if (!splitTestEnabled('istock-alt-popup-triggers')) return false;
  if (document.body.classList.contains('is-mobile')) return false;

  return true;
};

export const thirtyMinutesFromNow = () => (
  new Date(new Date().getTime() + 30 * 60 * 1000)
);

export const subId1Suffix = () => {
  const { splitTestName, splitTestVariant } = getCurrentUserState();

  if (!splitTestName || !splitTestVariant) return '';

  return `-${splitTestName}-${splitTestVariant}`;
};

export const openPopup = (url) => {
  Cookies.set(PARTNER_POPUP_SEEN_RECENTLY, { lastSeen: Date.now() });

  Cookies.remove(PARTNER_POPUP_PAGINATION);
  Cookies.remove(PARTNER_POPUP_SEARCH_VIEWS);
  Cookies.remove(PARTNER_POPUP_SHOW_VIEWS);

  const popup = new EzPopunder();

  popup.open(url);
};

const popupUrl = ({
  baseUrl, subId1, subId3, searchTerm,
}) => {
  const destinationUrl = document.body.dataset.partnerPopupDestinationUrl.replace(/{{search_term}}/g, searchTerm);

  const params = {
    u: encodeURIComponent(destinationUrl),
    sharedid: window.location.hostname,
    subId1: `${subId1}${subId1Suffix()}`,
    subId2: document.body.dataset.pageviewGuid,
    subId3,
    adtype: Cookies.get('content_type') || 'vector',
    adplacement: 'POP',
  };

  return `${baseUrl}?${Object.keys(params).map((k) => `${k}=${params[k]}`).join('&')}`;
};

export const displaySearchPopup = ({ searchTerm }) => {
  if (!canSeePartnerPopup()) return;
  if (seenRecently()) return;

  const searchViews = Cookies.get(PARTNER_POPUP_SEARCH_VIEWS) || 0;
  const newSearchViews = parseInt(searchViews, 10) + 1;

  if (searchTerm && newSearchViews >= PARTNER_POPUP_SEARCH_VIEWS_LIMIT) {
    const { impactRadiusSearchPopupUrl } = document.body.dataset;

    openPopup(
      popupUrl({
        baseUrl: impactRadiusSearchPopupUrl,
        searchTerm,
        subId1: 'SearchPopNoPricing',
        subId3: PARTNER_POPUP_SEARCH_VIEWS_LIMIT,
      }),
    );
  } else {
    Cookies.set(PARTNER_POPUP_SEARCH_VIEWS, newSearchViews, { expires: thirtyMinutesFromNow() });
  }
};

export const displayShowPopup = (params = { }) => {
  const { display = true, searchTerm } = params;
  if (seenRecently()) return;

  if (!canSeePartnerPopup()) return;

  const showViews = Cookies.get(PARTNER_POPUP_SHOW_VIEWS) || 0;
  const newShowViews = parseInt(showViews, 10) + 1;

  if (display && searchTerm && newShowViews >= PARTNER_POPUP_SHOW_VIEWS_LIMIT) {
    const { impactRadiusUrl } = document.body.dataset;

    openPopup(
      popupUrl({
        baseUrl: impactRadiusUrl,
        searchTerm,
        subId1: 'ShowPopNoPricing',
        subId3: PARTNER_POPUP_SHOW_VIEWS_LIMIT,
      }),
    );
  } else {
    Cookies.set(PARTNER_POPUP_SHOW_VIEWS, newShowViews, { expires: thirtyMinutesFromNow() });
  }
};
